var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m262.976 156.966-79.486 79.52c-4.683 4.685-12.275 4.685-16.958 0l-13.02-13.025c-4.683-4.685-4.683-12.281 0-16.966L199.987 160H20c-5.523 0-10-4.477-10-10v-20c0-5.523 4.477-10 10-10h179.987l-46.475-46.495c-4.683-4.685-4.683-12.28 0-16.966l13.02-13.025c4.683-4.685 12.275-4.685 16.958 0l79.486 79.52c9.365 9.37 9.365 24.562 0 33.932"
})));
export default SvgArrowRight;